import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* getAllTherapistList(action: any): SagaReturnType<any> {
  try {
    const response = yield call(therapistSchedulingServices.getAllTherapistList, action.payload);

    if (response?.status === 200) {
      yield put({
        type: TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_SUCCESS,
        payload: {
          ...response.data,
          localDate: action?.payload?.data?.localDate,
          // THIN-7718: the localDate echo above already guards against a stale response
          // for a different date landing on the current board. Discipline needs the same
          // treatment — this watcher is takeEvery and the abort ref is overwritten per
          // fetch, so a request issued for the previous discipline can resolve after the
          // current one and pollute the therapist column.
          discipline: action?.payload?.data?.discipline,
        },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({
      type: TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_FAILURE,
      payload: {
        ...error,
        localDate: action?.payload?.data?.localDate,
        discipline: action?.payload?.data?.discipline,
      },
    });
  }
}

function* getAllTherapistListSaga() {
  yield takeEvery(TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_REQUEST, getAllTherapistList);
}

export default getAllTherapistListSaga;
